/**
 * The LifeSpark Foundation — central brand & charity reference.
 *
 * Single source of truth for the public-facing site.
 */
export const FOUNDATION = {
  name: 'The LifeSpark Foundation',
  shortName: 'LifeSpark Foundation',
  formerName: 'The Regros Foundation',

  // Governance
  structure: 'Charitable Incorporated Organisation (CIO)',
  charityNumber: '1185541',
  registeredDate: '27 September 2019',
  jurisdictions: 'England, Wales and Scotland',

  // Contact
  email: 'hello@lifespark360.com',
  url: 'https://lifespark360.com',

  // Mission
  tagline: 'Empowering people to reach their full potential.',
  mission:
    'The LifeSpark Foundation helps people up-skill, leverage their strengths, and become self-sustaining — so that those we empower can go on to support and mentor others seeking to improve their lives.',

  // Flagship programme (registered trademark, delivered by the Foundation)
  programme: {
    name: 'LifeSpark360',
    trademark: 'LifeSpark360™',
  },
} as const;

/** External link to the live readiness assessment. */
export const ASSESSMENT_URL = 'https://assessment.lifespark360.com/';

/**
 * External link to the LifeSpark courses website (opens in a new tab).
 * Currently the "IT Budgeting for IT Service Managers" course.
 */
export const COURSES_URL = 'https://it01.lifespark360.org';

/** What the charity does — registered charitable purposes. */
export const CHARITABLE_PURPOSES = [
  'Education and training',
  'The prevention or relief of poverty',
  'Economic, community development and employment',
  'The advancement of health or saving of lives',
  'Support for people living with disability',
  'General charitable purposes',
] as const;

/** How the charity helps. */
export const HOW_WE_HELP = [
  'Provides services',
  'Provides advocacy, advice and information',
  'Makes grants to individuals',
  'Makes grants to organisations',
  'Provides other finance',
  'Provides buildings, facilities and open space',
  'Sponsors or undertakes research',
  'Acts as an umbrella or resource body',
] as const;
